declare var asset_url: string;

if (typeof asset_url !== 'undefined' && asset_url) {
  __webpack_public_path__ = asset_url;
} else if (process.env.PUBLIC_PATH) {
  __webpack_public_path__ = process.env.PUBLIC_PATH;
}
